// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"32b2ec93","439":"54989d25","632":"1cd225e1","879":"b37ab845","967":"62b3a3f5"}[chunkId] + ".chunk.js";
};